<template>
	<ViewFeedItem class="view-user-recentcheckins">
		<template v-slot:header>
			<ViewLayoutModuleHeader v-bind:title="userModel.getFirstName() + '\'s Recent Checkins'">
				<!-- <RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink> -->
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyVenueList
				class="horizontal"
				v-bind:key="venueCheckinCollection.uniqueKey"
				v-bind:venueCollection="filteredVenueCollection"
				v-if="filteredVenueCollection.length"
				v-on:venue:select="Handle_OnSelectVenue"
			/>

			<section v-else>
				<ViewUiCalloutIcon v-bind:message="message" iconFilename="pin.svg" />
			</section>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import * as Factory from '@/App/Factory';
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, event, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/User
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUserRecentCheckins extends ViewBase {
		/**
		 * Returns a filtered collection of venue check-ins.
		 *
		 * @return ChalkySticks.Collection.VenueCheckin
		 */
		protected get filteredVenueCollection(): ChalkySticks.Collection.VenueCheckin {
			const uniqueVenues = new Map<string, ChalkySticks.Model.Venue>();

			this.venueCheckinCollection.each((checkin: ChalkySticks.Model.VenueCheckin) => {
				uniqueVenues.set(checkin.venue.id, checkin.venue);
			});

			return ChalkySticks.Collection.VenueCheckin.hydrate(Array.from(uniqueVenues.values() || []));
		}

		/**
		 * @return string
		 */
		protected get message(): string {
			return this.userModel.getFirstName() + ' has not checked in<br />at any places yet';
		}

		/**
		 * @type ChalkySticks/Model/User
		 */
		@Prop({
			default: () => new ChalkySticks.Model.User(),
		})
		public userModel!: ChalkySticks.Model.User;

		/**
		 * @type ChalkySticks/Collection/VenueCheckin
		 */
		@Prop({
			default: () =>
				new ChalkySticks.Collection.VenueCheckin({
					atRelationship: ['venue'],
					limit: 8,
				}),
		})
		public venueCheckinCollection!: ChalkySticks.Collection.VenueCheckin;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectVenue(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.$store.dispatch('gotoVenue', venueModel);
		}

		// endregion: Event Handlers
	}
</script>
